import MacleJSBridge from 'src/bridges';
import { APINames } from 'src/shared';
import { GeneralInvokeOption } from 'src/types';

// 清理本地数据缓存
export function clearStorage(option?: GeneralInvokeOption) {
  return MacleJSBridge.beforeInvoke(APINames.Native.CLEAR_STORAGE, option);
}
